import { multipart_headers } from "../state/helpers";
export const bannerService = {
  getBanner: (data) => window.axios.post("get-web-banner", data),
  getPrivateCharger: (data) =>
    window.axios.post("get-all-private-charger", data),
  getUsers: (data) => window.axios.post("get-users", data),
  showBanner: (data) => window.axios.post("show-banner", data),
  deleteBanner: (data) => window.axios.post("delete-banner", data),
  addOrUpdateBanner: (data) =>
    window.axios.post("store-or-update-benner-web", data, {
      headers: multipart_headers(),
    }),
  getMonthWiseBooking: (data) =>
    window.axios.post("get-month-wise-booking", data),
  getMonthWiseEarning: (data) =>
    window.axios.post("get-month-wise-earning", data),
  getAllChargersDetail: (data) =>
    window.axios.post("get-all-chargers-data", data),
};
